var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { t } from 'i18next';
import { BaseComponent } from '../../utils/BaseComponent';
let Badges = class Badges extends BaseComponent {
    constructor() {
        super(...arguments);
        this.small = false;
    }
    render() {
        if (this.categoryScore.score < 0.75)
            return nothing;
        const badgeText = (categoryText) => html `<p class=${this.small ? 'caption' : ''}>
              ${categoryText}
            </p>`;
        const createBadge = (classnames) => {
            switch (this.categoryScore.category) {
                case 'AS_ADVERTISED':
                    return html `
             <trust-icon name="AsAdvertised" classNames="${classnames}" ></trust-icon>
            ${badgeText(t(this.categoryScore.category))}
          `;
                case 'COMMUNICATION':
                    return html `
            <trust-icon name="Communication" classNames="${classnames}" ></trust-icon>
            ${badgeText(t(this.categoryScore.category))}
          `;
                case 'TRANSACTION':
                    return html `
            <trust-icon name="Transaction" classNames="${classnames}" ></trust-icon>
            ${badgeText(t(this.categoryScore.category))}
          `;
                case 'PAYMENT':
                    return html `
            <trust-icon name="Payment" classNames="${classnames}" ></trust-icon>
            ${badgeText(t(this.categoryScore.category))}
          `;
                default:
                    return undefined;
            }
        };
        const badge = createBadge('ml-8 mr-16 w-24 h-24');
        if (!badge) {
            return nothing;
        }
        ;
        return html `
      <li class='flex mt-16 items-center'>
        ${badge}
      </li>
    `;
    }
};
__decorate([
    property({ type: Boolean })
], Badges.prototype, "small", void 0);
__decorate([
    property()
], Badges.prototype, "categoryScore", void 0);
Badges = __decorate([
    customElement('trust-summary-badges')
], Badges);
export { Badges };
//# sourceMappingURL=Badges.js.map